import { MockedProvider } from "@apollo/client/testing";
import React, { useMemo } from "react";
import { MockedAuthManager } from "../../contexts/AuthManager";
import { buildActivityLog, buildUser } from "../factories";
import { ACK_ACTIVITY_LOG, GET_ACTIVITY_LOG_FEED } from "../../graphql/activity";
import { ProfileType } from "../../__generated__/graphql";
import { ScrollView } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";
import { MockedProfileSwitcherManager } from "../../contexts/ProfileSwitcherManager";
import UserLogsScreen from "../../screens/user/UserLogs";

const StoryComponent = ({ profileType }: { profileType: ProfileType }) => {
    const mocks = [
        {
            request: {
                query: GET_ACTIVITY_LOG_FEED,
            },
            variableMatcher: () => true,
            result: () => {
                return {
                    data: {
                        getActivityLogFeed: {
                            elements: [
                                buildActivityLog({ id: "log-1" }),
                                buildActivityLog({ id: "log-2" }),
                            ],
                            pageInfo: {
                                currentOffset: 0,
                                previousOffset: -1,
                                nextOffset: -1,
                                hasNextPage: false,
                                hasPreviousPage: false,
                                limit: 100,
                            },
                        },
                    },
                };
            },
        },
        {
            request: {
                query: ACK_ACTIVITY_LOG,
            },
            variableMatcher: () => true,
            newData: ({ logId }: { logId: string }) => {
                return {
                    data: {
                        ackActivityLog2: {
                            hasBeenAcknowledge: true,
                            activityLog: buildActivityLog({ id: logId }),
                        },
                    },
                };
            },
        },
    ];
    const user = useMemo(buildUser, []);

    return (
        <MockedAuthManager user={user}>
            <MockedProfileSwitcherManager profileType={profileType}>
                <MockedProvider mocks={mocks}>
                    <UserLogsScreen />
                </MockedProvider>
            </MockedProfileSwitcherManager>
        </MockedAuthManager>
    );
};

const meta = {
    title: "Screens/Logs",
    component: StoryComponent,
    argTypes: {
        profileType: {
            options: [ProfileType.Worker, ProfileType.Client],
            control: { type: "radio" },
        },
    },
    decorators: [
        (StoryFn) => (
            <ScrollView>
                <StoryFn />
            </ScrollView>
        ),
    ],
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Worker: Story = {
    args: {
        profileType: ProfileType.Worker,
    },
};

export const Client: Story = {
    args: {
        profileType: ProfileType.Client,
    },
};
